export default "__VITE_ASSET__D8kSK_x5__"